const UUID_V4_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

class StringUtils {
  public static isUUIDv4 = (param: string): boolean => {
    return UUID_V4_PATTERN.test(param);
  };
}

export default StringUtils;
